module.exports = __webpack_public_path__ + "img/i_plus_big.5930ce28.svg";